import { describeMutationError } from "@api/mutationErrors";
import {
  Button,
  ConfirmDialog,
  FieldError,
} from "@scribenote/brian-design-system";
import { useState } from "react";

import type { ListedDisplay } from "./displaysClient";
import { useUnpairDisplay } from "./displaysQueries";

export const UnpairDisplayButton = ({
  display,
  sessionKey,
}: {
  display: ListedDisplay;
  sessionKey: string;
}) => {
  const [confirming, setConfirming] = useState(false);
  const unpair = useUnpairDisplay(sessionKey);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setConfirming(true)}
        data-testid="admin-display-unpair"
      >
        Unpair
      </Button>

      <ConfirmDialog
        open={confirming}
        title={`Unpair ${display.name}?`}
        confirmLabel="Unpair"
        busy={unpair.isPending}
        onCancel={() => {
          unpair.reset();
          setConfirming(false);
        }}
        onConfirm={() =>
          unpair.mutate(display.id, { onSuccess: () => setConfirming(false) })
        }
        confirmTestId="admin-display-unpair-confirm"
      >
        <p className="text-sm text-ink-body">
          The screen goes back to showing a pairing code.
        </p>
        {unpair.isError && (
          <FieldError className="mt-2">
            {describeMutationError(unpair.error, "unpair the screen")}
          </FieldError>
        )}
      </ConfirmDialog>
    </>
  );
};
